export default {
  name: 'actions',
  props: {
  	items: {
      type: Array
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/battle/actions/actions.js